import axios from '@axios'

export default {
    namespaced: true, state: {}, getters: {}, mutations: {}, actions: {

        fetchComplainList(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios.get(`/admin-company/v1/app/user-complain/${queryParams.options.page}/${queryParams.options.itemsPerPage}`, { params: queryParams.query }).then(response => resolve(response)).catch(error => reject(error))
            })
        },
        ignoreComplain(ctx, data) {
            return new Promise((resolve, reject) => {
                axios.put(`/admin-company/v1/app/user-complain/ignore/${data.id}`).then(response => resolve(response)).catch(error => reject(error))
            })
        },
        replyComplain(ctx, data) {
            return new Promise((resolve, reject) => {
                axios.put(`/admin-company/v1/app/user-complain/reply/${data.id}`, data).then(response => resolve(response)).catch(error => reject(error))
            })
        },
    },
}
